var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "752pt",
    height: "752pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376 444.67c37.887 0 68.668-30.781 68.668-68.668 0-37.887-30.781-68.668-68.668-68.668-37.887-0.003907-68.668 30.777-68.668 68.664s30.781 68.672 68.668 68.672zm-5.207-111.77v22.73c-8.5234 0-15.629 7.1055-15.629 15.629h-22.73c0.47266-21.312 17.52-38.359 38.359-38.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 513.34c102.29 0 185.17-94.242 208.38-123.13 6.6289-8.0508 6.6289-19.891 0-28.414-23.207-28.887-106.08-123.13-208.38-123.13-102.29 0.003906-185.17 94.246-208.38 123.13-6.6289 8.0508-6.6289 19.891 0 28.414 23.207 28.891 106.08 123.13 208.38 123.13zm0-236.79c54.934 0 99.453 44.516 99.453 99.453 0 54.934-44.516 99.453-99.453 99.453-54.934 0-99.453-44.516-99.453-99.453 0.003906-54.938 44.52-99.453 99.453-99.453z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.c8b17bbeb82537344b48cec4a873738e.svg";
export { ForwardRef as ReactComponent };